<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end"
  colorScheme="dark"
  id="sidebar1"
  visible
>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand [routerLink]="[]">
      <!-- <svg [class]="{icon: false}" cIcon class="sidebar-brand-full" height="32" name="logo" title="CoreUI Logo"></svg>
      <svg cIcon class="sidebar-brand-narrow" height="32" name="signet" title="CoreUI Logo"></svg> -->
      <svg
        width="175"
        height="32"
        viewBox="0 0 6317 926"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2395.28 12.3086V912.569H2210.66L1852.4 392.989H1846.69V912.569H1629.1V12.3086H1816.36L2170.66 531.009H2178.13V12.3086H2395.28Z"
          fill="#0099E0"
        />
        <path
          d="M2962.2 282.21C2959.27 249.98 2946.3 224.84 2923.3 206.82C2900.29 188.8 2867.54 179.79 2825.05 179.79C2796.92 179.79 2773.47 183.46 2754.72 190.78C2735.96 198.11 2721.9 208.14 2712.52 220.89C2703.14 233.64 2698.3 248.22 2698.01 264.63C2697.42 278.11 2700.13 289.98 2706.14 300.24C2712.14 310.5 2720.94 319.51 2732.51 327.27C2744.08 335.04 2758.07 341.85 2774.49 347.71C2790.9 353.57 2809.36 358.7 2829.88 363.1L2907.25 380.68C2951.79 390.35 2991.13 403.25 3025.28 419.36C3059.42 435.48 3088.14 454.68 3111.44 476.94C3134.74 499.21 3152.39 524.85 3164.41 553.87C3176.42 582.88 3182.58 615.41 3182.87 651.46C3182.57 708.32 3168.21 757.11 3139.79 797.84C3111.36 838.58 3070.56 869.79 3017.37 891.47C2964.18 913.15 2900.07 924 2825.05 924C2750.03 924 2684.09 912.71 2628.12 890.15C2572.14 867.59 2528.62 833.3 2497.57 787.29C2466.5 741.29 2450.53 683.11 2449.65 612.78H2658.01C2659.77 641.79 2667.53 665.97 2681.31 685.31C2695.08 704.65 2714.06 719.31 2738.24 729.27C2762.42 739.24 2790.48 744.22 2822.42 744.22C2851.72 744.22 2876.71 740.26 2897.37 732.35C2918.03 724.44 2933.92 713.45 2945.06 699.38C2956.19 685.31 2961.91 669.2 2962.2 651.03C2961.9 634.04 2956.63 619.46 2946.38 607.29C2936.12 595.13 2920.37 584.58 2899.13 575.64C2877.88 566.7 2850.85 558.43 2818.03 550.8L2723.96 528.82C2646 510.95 2584.61 482 2539.78 442C2494.94 402 2472.67 347.86 2472.96 279.58C2472.66 223.9 2487.61 175.11 2517.8 133.2C2547.98 91.3 2589.74 58.62 2643.08 35.17C2696.41 11.73 2757.22 0 2825.51 0C2893.8 0 2955.85 11.8 3007.28 35.39C3058.71 58.98 3098.64 92.03 3127.07 134.51C3155.49 177 3170 226.24 3170.59 282.21H2962.23H2962.2Z"
          fill="#0099E0"
        />
        <path
          d="M3210.78 189.019V12.3086H3971.69V189.019H3698.71V912.569H3484.19V189.019H3210.77H3210.78Z"
          fill="#0099E0"
        />
        <path
          d="M4484.34 912.569H4718.2L4414.45 12.3086H4124.77L3821.02 912.569H4054.88L4114.1 723.549H4425L4484.35 912.569H4484.34ZM4165.88 558.269L4265.87 239.139H4272.9L4373.1 558.269H4165.88Z"
          fill="#0099E0"
        />
        <path
          d="M5485.44 338.48H5265.65C5262.72 315.92 5256.71 295.55 5247.63 277.38C5238.54 259.21 5226.53 243.68 5211.58 230.79C5196.63 217.9 5178.97 208.01 5158.61 201.12C5138.24 194.24 5115.75 190.79 5091.13 190.79C5047.46 190.79 5009.88 201.49 4978.38 222.88C4946.87 244.28 4922.7 275.19 4905.85 315.63C4888.99 356.07 4880.57 405.02 4880.57 462.45C4880.57 519.88 4889.14 572.28 4906.29 612.57C4923.43 652.87 4947.61 683.2 4978.82 703.56C5010.03 723.93 5047.02 734.11 5089.81 734.11C5113.84 734.11 5135.75 731.03 5155.53 724.88C5175.31 718.73 5192.74 709.71 5207.84 697.85C5222.93 685.98 5235.38 671.48 5245.2 654.33C5255.02 637.19 5261.83 617.78 5265.64 596.09L5485.43 597.41C5481.62 637.27 5470.11 676.53 5450.92 715.22C5431.72 753.9 5405.42 789.15 5372.02 820.94C5338.61 852.74 5297.95 878.02 5250.04 896.77C5202.13 915.52 5147.25 924.9 5085.42 924.9C5003.95 924.9 4931.05 906.95 4866.73 871.05C4802.4 835.16 4751.63 782.77 4714.42 713.9C4677.2 645.04 4658.59 561.22 4658.59 462.46C4658.59 363.7 4677.49 279.45 4715.29 210.58C4753.09 141.72 4804.23 89.4095 4868.7 53.6495C4933.17 17.8995 5005.41 0.0195312 5085.41 0.0195312C5139.92 0.0195312 5190.32 7.56955 5236.63 22.6595C5282.93 37.7595 5323.67 59.7395 5358.83 88.5995C5394 117.47 5422.57 152.85 5444.55 194.76C5466.53 236.67 5480.16 284.59 5485.43 338.5L5485.44 338.48Z"
          fill="#0099E0"
        />
        <path
          d="M6283.67 925.82C6258.52 925.82 6232.94 922.68 6206.97 916.39C6180.98 910.1 6154.98 899.63 6129.01 884.95C6103.02 870.29 6076.2 851.22 6048.54 827.74L5781.97 596.38V913.25H5568.21V12.2402H5781.97V337.36L6096.32 605.19C6120.62 625.31 6142.41 642.09 6161.71 655.49C6180.98 668.91 6198.59 679.18 6214.52 686.3C6230.43 693.43 6245.11 698.87 6258.53 702.65C6271.93 706.42 6284.5 708.31 6296.25 708.31H6306.31C6309.65 708.31 6313.01 707.48 6316.37 705.8V923.33C6310.5 924.16 6304.84 924.78 6299.39 925.22C6293.93 925.63 6288.7 925.85 6283.67 925.85V925.82Z"
          fill="#0099E0"
        />
        <path
          d="M5928.57 462.831L5756 348.771C5962.29 256.531 6079.32 69.0808 6084.28 12.5508H6280.66C6235.04 207.931 6134.87 342.821 5928.57 462.821V462.831Z"
          fill="#0099E0"
        />
        <path
          d="M898.51 912.929V12.5586H1544.2V197.779H1115.88V367.559H1510.76V542.489H1115.88V730.279H1568.64V912.929H898.51Z"
          fill="#0099E0"
        />
        <path
          d="M21.9449 602.655L124.138 500.462V602.655H21.9449Z"
          fill="#0099E0"
        />
        <path d="M0 633.69H124.138V757.828H0V633.69Z" fill="#0099E0" />
        <path d="M155.172 913V788.862H589.655V913H155.172Z" fill="#0099E0" />
        <path
          d="M620.69 891.055V779.772L744.828 655.635V766.917L620.69 891.055Z"
          fill="#0099E0"
        />
        <path
          d="M722.883 633.69L598.745 757.828H177.117L301.255 633.69H722.883Z"
          fill="#0099E0"
        />
        <path
          d="M257.365 633.69L155.172 735.883V633.69H257.365Z"
          fill="#0099E0"
        />
        <path
          d="M155.172 602.655V478.517H434.483V602.655H155.172Z"
          fill="#0099E0"
        />
        <path
          d="M443.572 447.483H177.117L301.255 323.345H567.71L443.572 447.483Z"
          fill="#0099E0"
        />
        <path
          d="M155.172 323.345H257.365L155.172 425.538V323.345Z"
          fill="#0099E0"
        />
        <path d="M124.138 323.345V447.483H0V323.345H124.138Z" fill="#0099E0" />
        <path
          d="M124.138 292.31H21.9449L124.138 190.117V292.31Z"
          fill="#0099E0"
        />
        <path
          d="M155.172 292.31V168.172H589.655V292.31H155.172Z"
          fill="#0099E0"
        />
        <path
          d="M620.69 270.366V159.082L744.828 34.9446V146.228L620.69 270.366Z"
          fill="#0099E0"
        />
        <path
          d="M301.255 13H722.883L598.745 137.138H177.117L301.255 13Z"
          fill="#0099E0"
        />
        <path
          d="M465.517 469.428L589.655 345.29V456.572L465.517 580.71V469.428Z"
          fill="#0099E0"
        />
      </svg>
    </c-sidebar-brand>
  </c-sidebar-header>

  <ng-scrollbar
    #scrollbar="ngScrollbar"
    (updated)="onScrollbarUpdate(scrollbar.state)"
    class="overflow"
    pointerEventsMethod="scrollbar"
    visibility="hover"
  >
    <c-sidebar-nav
      #overflow
      [navItems]="navItems"
      dropdownMode="close"
      compact
    />
  </ng-scrollbar>
  <!-- @if (!sidebar1.narrow) {
  <c-sidebar-footer
    cSidebarToggle="sidebar1"
    class="border-top d-none d-lg-flex"
    toggle="unfoldable"
    style="cursor: pointer"
  >
    <button cSidebarToggler aria-label="Toggle sidebar fold"></button>
  </c-sidebar-footer>
  } -->
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header
    [cShadowOnScroll]="'sm'"
    class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
  />
  <!--app-body-->
  <div class="body flex-grow-1">
    <c-container breakpoint="lg" class="h-auto px-4">
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <!-- <app-default-footer /> -->
</div>
